/**
 * Portal Manta · PRESETS_NOVO_ESTUDO
 * Extraído de App.jsx v29.3 (via AST)
 */
import { S, extKm } from '../globals.js';

const PRESETS_NOVO_ESTUDO = [
  {
    id: 'pr-lote3',
    titulo: 'PR · Lote 3',
    descricao: 'Referência ANTT recente · BR-376/BR-101',
    quali: {
      ufPrincipal:'PR', tipoObra:'Concessão Rodoviária Federal', regulador:'ANTT',
      fiscalSec:'PRF, BPRv', financiador:'BNDES',
      ctxRural:75, ctxUrbano:15, ctxSerra:10,
      chuvaMM:1500, chuvaDias:130, chuvaRegime:'Subtropical',
      altitudeMedia:900, biomaPredominante:'Mata Atlântica',
      prazoAnos:30, nivelDetalhe:'PER + MEF', fonteOrcamento:'SICRO', anoBaseSicro:'2024',
    },
    quanti: {
      extKm:570, dupKm:280, fxKm:80, ciclKm:0,
      oaeQt:60, passQt:8, interQt:75, areaEscapeQt:2,
    },
  },
  {
    id: 'pr-lote4',
    titulo: 'PR · Lote 4',
    descricao: 'BR-272/PR-323 · concessão recente',
    quali: {
      ufPrincipal:'PR', tipoObra:'Concessão Rodoviária Federal', regulador:'ANTT',
      fiscalSec:'PRF, BPRv', financiador:'BNDES',
      ctxRural:80, ctxUrbano:10, ctxSerra:10,
      chuvaMM:1450, chuvaDias:125, chuvaRegime:'Subtropical',
      altitudeMedia:700, biomaPredominante:'Mata Atlântica',
      prazoAnos:30, nivelDetalhe:'PER + MEF', fonteOrcamento:'SICRO', anoBaseSicro:'2024',
    },
    quanti: {
      extKm:447, dupKm:200, fxKm:60, ciclKm:0,
      oaeQt:45, passQt:5, interQt:55, areaEscapeQt:1,
    },
  },
  {
    id: 'pr-lote1',
    titulo: 'PR · Lote 1 (dados PER reais)',
    descricao: '473,01 km · 343,81 km duplicação · 98 interseções',
    quali: {
      nome:'Lote 1 · Paraná · BR-277/BR-373/BR-376/BR-476',
      ufPrincipal:'PR', tipoObra:'Concessão Rodoviária Federal', regulador:'ANTT',
      fiscalSec:'PRF, BPRv', financiador:'BNDES',
      ctxRural:75, ctxUrbano:15, ctxSerra:10,
      chuvaMM:1500, chuvaDias:130, chuvaRegime:'Subtropical',
      altitudeMedia:900, biomaPredominante:'Mata Atlântica',
      prazoAnos:30, dataEstudo:'2023-05-02',
      nivelDetalhe:'PER + MEF', fonteOrcamento:'SICRO', anoBaseSicro:'2024',
      notas:'Lote 1 do leilão PR 2023 · 7 rodovias (4 federais + 3 estaduais) · dados PER Vol I+II',
    },
    quanti: {
      extKm:473.01, extPistaSimples:384.42, extPistaDupla:88.59,
      dupKm:343.81, ciclKm:13.7,
      oaeQt:70, passQt:12, areaEscapeQt:1,
      interQt:98, retornoXQt:9, margTrechos:28, acessosQt:92, travUrbanasQt:27,
      correcoesTracadoQt:20, ilumCurvasQt:44,
    },
  },
  {
    id: 'pr-vazio',
    titulo: 'PR · Vazio',
    descricao: 'Só média de chuva do PR · resto em branco',
    quali: {
      ufPrincipal:'PR', chuvaMM:1500, chuvaDias:130, chuvaRegime:'Subtropical',
      biomaPredominante:'Mata Atlântica',
    },
    quanti: {},
  },
];

export { PRESETS_NOVO_ESTUDO };
export default PRESETS_NOVO_ESTUDO;
